import { VideoEvents } from "../../../globals";
import { useVideoElementRefContext } from "../../contexts/VideoElementRefContext";
import { useEffect } from "react";

/**
 * Custom hook to log video events to the window object.
 * This hook listens for new video data and updates the window.orcaPlayers object
 * with the current video data and events.
 * @param {object} videoData
 * @param {string} videoId
 */
export const useOrcaLogs = (videoData, videoId) => {
  const videoElementRef = useVideoElementRefContext();

  useEffect(() => {
    const newVideoEvent = new CustomEvent(VideoEvents.NEW_VIDEO_DATA, {
      detail: videoData
    });
    videoElementRef.current?.dispatchEvent(newVideoEvent);

    // For each new video, setup a window object to track events
    if (typeof window !== "undefined" && videoData) {
      window.orcaPlayers = window.orcaPlayers || {};

      window.orcaPlayers[videoId] = window.orcaPlayers[videoId] || {
        data: videoData,
        events: []
      };

      window.orcaPlayers[videoId].data = videoData;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoData?._id]);
};
